import { Component, inject, Input, LOCALE_ID, OnInit } from '@angular/core'

import type { CountryListItem } from '@app/generated/api/model'

@Component({
  selector: 'app-flag',
  templateUrl: 'flag.component.html',
})

export class FlagComponent implements OnInit {
  public readonly locale = inject(LOCALE_ID)

  @Input() country?: CountryListItem | null
  @Input() forceLocale?: string

  countryLabel: string = ''
  countryIsoCode: string = ''

  ngOnInit (): void {
    if (!this.country) return

    this.countryIsoCode = this.country.code_iso_2?.toLocaleLowerCase() ?? ''

    this.countryLabel = this.country?.label_en
    if (this.locale === 'fr' || this.forceLocale === 'fr') {
      this.countryLabel = this.country?.label_fr
    }
  }
}
